import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AlertSettings } from "@/features/settings/components/alert-settings";
import { PageContainer } from "@/components/ui/page-container";

function AlertsSettingsPage() {
  return (
    <PageContainer maxWidth="2xl">
      <AlertSettings />
    </PageContainer>
  );
}

export const settingsAlertsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/settings/alerts",
  component: AlertsSettingsPage,
});
